import type { Round } from './types';

/* PHASE 1 ONLY — DELETE IN PHASE 4.
   The round that shipped in the static prototype, so the play view is verifiable at the real
   URL before PocketBase, auth or the write path exist. Phase 4 replaces this with the API and
   this file goes away; nothing else should ever import it.

   Image paths go through import.meta.env.BASE_URL so they stay absolute: a relative URL
   would resolve against /real-or-fake/play/<token>/ on a deep link and 404.

   All 8 source URLs verified 200 on 2026-08-10. Two look wrong and are not: abcnews.com is
   ABC's canonical domain, and the Fox golf story really does sit under /sports/. */

export const STATIC_ROUND: Round = {
  id: 'static-round-1',
  title: 'Series 1',
  ribbonLabel: 'FABRICATED',
  items: [
    {
      id: 's1',
      verdict: 'real',
      headline: 'United Refused To Let An Emotional Support Peacock Board Plane',
      sourceName: 'CNBC',
      sourceUrl:
        'https://www.cnbc.com/2018/01/31/united-refused-to-let-an-emotional-support-peacock-board-plane.html',
    },
    {
      id: 's2',
      verdict: 'real',
      headline: 'Bear Gets Trapped Inside SUV, Honks Horn All Night',
      sourceName: 'UPI',
      sourceUrl:
        'https://www.upi.com/Odd_News/2026/07/22/bear-trapped-SUV-honks-horn-Gold-Hill-Colorado/3221784732774/',
    },
    {
      id: 's3',
      verdict: 'real',
      headline: "Florida Man Arrested For Allegedly Tossing Alligator Into Wendy's Drive-Thru Window",
      sourceName: 'ABC News',
      sourceUrl:
        'https://abcnews.com/US/florida-man-arrested-allegedly-tossing-alligator-wendys-drive/story?id=36815270',
    },
    {
      id: 's4',
      verdict: 'real',
      headline: 'Escaped Prisoner Turns Himself In After 39 Years For The Health Care',
      sourceName: 'NBC News',
      sourceUrl:
        'https://www.nbcnews.com/news/us-news/escaped-prisoner-turns-himself-after-39-years-health-care-n345986',
    },
    {
      id: 's5',
      verdict: 'fake',
      headline: 'City Council Votes To Rename Pothole After It Becomes Local Landmark',
      images: [`${import.meta.env.BASE_URL}round-assets/fake-graphic-pothole-placeholder.jpg`],
      body: '',
      footerNote: '',
    },
    {
      id: 's6',
      verdict: 'real',
      headline: 'Police Deploy Riot Shields To Rescue Runaway Goat Who Caused Havoc In Quiet Village',
      sourceName: 'LBC',
      sourceUrl: 'https://www.lbc.co.uk/article/police-riot-shields-runaway-goat-5HjdPjD_2/',
    },
    {
      id: 's7',
      verdict: 'real',
      headline: 'Gary Rough Jailed Over Robbery Bid With Cucumber',
      sourceName: 'BBC',
      sourceUrl: 'https://www.bbc.com/news/uk-scotland-glasgow-west-26370484',
    },
    {
      id: 's8',
      verdict: 'fake',
      headline: 'Museum Mistakenly Displays IKEA Rug As 18th-Century Artifact',
      images: [`${import.meta.env.BASE_URL}round-assets/fake-graphic-museum-placeholder.jpg`],
      body: '',
      footerNote: '',
    },
    {
      id: 's9',
      verdict: 'real',
      headline: 'Overdue Book Returned To California Library After Nearly 100 Years',
      sourceName: 'ABC News',
      sourceUrl:
        'https://abcnews.go.com/US/overdue-book-returned-california-library-after-100-years/story?id=99584376',
    },
    {
      id: 's10',
      verdict: 'real',
      headline: "Teen's Golf Ball Struck By Lightning",
      sourceName: 'Fox News',
      sourceUrl: 'https://foxnews.com/sports/teen-golf-ball-struck-lightning',
    },
  ],
};
